import { render } from "./typingHeader.vue?vue&type=template&id=e5d0c3e4&scoped=true&ts=true"
import script from "./typingHeader.vue?vue&type=script&lang=ts"
export * from "./typingHeader.vue?vue&type=script&lang=ts"

import "./typingHeader.vue?vue&type=style&index=0&id=e5d0c3e4&scoped=true&lang=css"

import exportComponent from "D:\\chat-tx\\chat-example\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5d0c3e4"]])

export default __exports__